import type { JourneySettingsProps } from "@hightouch/formkit";
import type { SharedProps } from ".";
import { JourneySettings } from "src/formkit/components";
import { useFormContext } from "react-hook-form";

export const FKJourneySettings = ({
  name,
  isDisabled,
  formNodeContext,
}: JourneySettingsProps & SharedProps & { formNodeContext?: any }) => {
  const form = useFormContext();

  const handleClear = () => {
    // Set explicit null values to override template fallback
    form.setValue(`${name}.mode`, null, { shouldDirty: true });
    form.setValue(`${name}.exit_config`, null, { shouldDirty: true });
  };

  return (
    <JourneySettings
      name={name}
      isDisabled={isDisabled}
      showClearable={formNodeContext?.showClearable}
      onClear={handleClear}
      showLocks={formNodeContext?.showLocks}
    />
  );
};
